module.exports = {
      id: "fallback-image-usage",
      viewBox: "0 0 102 76",
      url: __webpack_public_path__ + "svg-sprite-9780240c1c89505db7f372dec3b5867e.svg#fallback-image",
      toString: function () {
        return this.url;
      }
    }